<!-- AlloyConfigSection.vue -->
<template>
  <div
    v-if="configType === 'alloyconfig' && !isGeneralFileUpload"
    class="space-y-6"
  >
    <AlloyOtlpSection v-if="isStaff" :model-value="modelValue" :errors="errors" @clear-error="$emit('clear-error', $event)" @start-tutorial="$emit('start-tutorial', 'otlp')" />
    <AlloyLoggingSection :model-value="modelValue" @start-tutorial="$emit('start-tutorial', 'logging')" />
    <AlloyLogSourcesSection :model-value="modelValue" :os-type="osType" @start-tutorial="$emit('start-tutorial', 'logsources')" />
    <AlloyMonitoringModulesSection :model-value="modelValue" :os-type="osType" :errors="errors" @clear-error="$emit('clear-error', $event)" @start-tutorial="$emit('start-tutorial', 'modules')" />
  </div>
</template>

<script setup>
import AlloyLoggingSection from '@/components/Workspace/AlloyLoggingSection.vue'
import AlloyOtlpSection from '@/components/Workspace/AlloyOtlpSection.vue'
import AlloyLogSourcesSection from '@/components/Workspace/AlloyLogSourcesSection.vue'
import AlloyMonitoringModulesSection from '@/components/Workspace/AlloyMonitoringModulesSection.vue'
import { computed } from 'vue'
import { useStore } from '@/store'

const isStaff = computed(() => useStore.isStaff())

defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  configType: {
    type: String,
    required: true
  },
  isGeneralFileUpload: {
    type: Boolean,
    default: false
  },
  osType: {
    type: String,
    default: ''
  },
  errors: {
    type: Object,
    default: () => ({})
  }
})

defineEmits(['update:modelValue', 'clear-error', 'start-tutorial'])
</script>
